import {Controller} from 'react-hook-form'
import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import ColorPicker from 'lib/ui/ColorPicker'
import Slider from 'lib/ui/Slider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'

export default function DescriptionConfig() {
  const saveTemplate = useSaveTemplate()
  const {signUp, login, textColor} = useTemplate()
  const addTranslation = useAddTranslation()
  const v = useAttendeeVariables()

  const descriptionTextColor =
    signUp.descriptionTextColor || login.description.color || textColor
  const descriptionFontSize =
    signUp.descriptionFontSize ?? login.description.fontSize

  const save = (data: any) => {
    const description = replaceAtPath(
      data,
      'signUp.description',
      '{{sign_up_description}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        sign_up_description: description ?? '',
      }),
    })
  }

  const {
    form: {register, control},
  } = useConfig()

  return (
    <Config title="Description" onSave={save}>
      <SettingsPanel>
        <TextField
          name="signUp.description"
          defaultValue={v(signUp.description)}
          label="Description"
          fullWidth
          inputProps={{
            'aria-label': 'set form description',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <Controller
          name="signUp.descriptionTextColor"
          defaultValue={descriptionTextColor}
          control={control}
          render={({value, onChange}) => (
            <ColorPicker
              label="Description Text Color"
              color={value}
              onPick={onChange}
              aria-label="description text color"
            />
          )}
        />
        <Controller
          name="signUp.descriptionFontSize"
          defaultValue={descriptionFontSize}
          control={control}
          render={({value, onChange}) => (
            <Slider
              valueLabelDisplay="auto"
              aria-label="description font size"
              value={value}
              onChange={onChange}
              step={1}
              min={5}
              max={50}
              label="Description Font Size"
            />
          )}
        />
      </StylingPanel>
    </Config>
  )
}
